import React from 'react';
import content from '../../content/content';

function Skills() {
    const renderSkillItem = (tech) => {
        const hasImage = Boolean(tech.img);
        return (
            <div key={tech.alt} className="flex flex-col items-center m-2">
                <span className="w-32 h-32 bg-white shadow-2xl rounded-full flex items-center justify-center p-5">
                    {hasImage ? (
                        <img src={tech.img} alt={tech.alt} />
                    ) : (
                        <span className="text-sm font-semibold text-gray-700 text-center leading-tight">
                            {tech.alt}
                        </span>
                    )}
                </span>
                <span className="text-xs font-medium text-gray-600 mt-2">{tech.alt}</span>
            </div>
        );
    };

    return (
        <div id="skill" className='min-h-screen bg-skill'>
            <h1 className='text-4xl font-semibold font-nunito text-center p-6 mb-4'>
                Skills
                <br />
                <span className='w-8 h-1 mb-5 bg-indigo-600 inline-block rounded-full' />
            </h1>
            <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-3'>

                <div className="flex flex-col items-center justify-start pt-4" data-aos="fade-right" data-aos-duration="2000">
                    <span className='text-2xl font-semibold mb-3'>Languages</span>
                    <div className="flex flex-wrap justify-center mt-4">
                        {content.language.tech.map(renderSkillItem)}
                    </div>
                </div>

                <div className="flex flex-col items-center justify-start pt-4" data-aos="zoom-in" data-aos-duration="2000">
                    <span className='text-2xl font-semibold mb-3'>Techs</span>
                    <div className="flex flex-wrap justify-center mt-4">
                        {content.techs.tech.map(renderSkillItem)}
                    </div>
                </div>

                <div className="flex flex-col items-center justify-start pt-4" data-aos="fade-left" data-aos-duration="2000">
                    <span className='text-2xl font-semibold mb-3'>Tools</span>
                    <div className="flex flex-wrap justify-center mt-4">
                        {content.tools.tech.map(renderSkillItem)}
                    </div>
                </div>
            </div>

            {/* AI Tools — second row, centered */}
            <div className="flex flex-col items-center justify-start pt-10 pb-16" data-aos="fade-up" data-aos-duration="2000">
                <span className='text-2xl font-semibold mb-3'>AI Tools</span>
                <div className="flex flex-wrap justify-center mt-10">
                    {content.aiTools.tech.map(renderSkillItem)}
                </div>
            </div>
        </div>
    );
}

export default Skills;